import "./welcome.css";

import React from "react";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";

import { PAGE_ROUTES } from "../../utils/stateTypes";
import SEO_DATA from "../../utils/seoData";
import SeoHead from "../general/SeoHead";

const styles = {
  headerButton: {
    padding: "15px 30px",
  },
};

const Welcome = () => (
  <main>
    <SeoHead
      {...SEO_DATA[PAGE_ROUTES.WELCOME]}
      path={PAGE_ROUTES.WELCOME}
    />

    {/* ================================== HERO ================================== */}
    <header className={"home-header"}>
      <div className={"standard-width"}>
        <div className={"home-header-content"}>
          <h1>Ash the dietitian</h1>
          <p>Making <i>food</i> and <i>exercise</i> a<br />part of your <i>balanced</i> lifestyle</p>
          <Link to={PAGE_ROUTES.BOOK}>
            <Button
              variant={"contained"}
              color={"primary"}
              style={styles.headerButton}
            >
              Book now
            </Button>
          </Link>
        </div>
      </div>
      <img
        src={"/images/home/landing-bg1.webp"}
        className={"home-header-img"}
        alt={"Ash The Dietitian - Cape Town & Online Dietitian"}
      />
    </header>

    {/* ================================== START TODAY ================================== */}
    <section className={"welcome-text-section standard-width"}>
      <h2 className={"section-head"}>Start today.</h2>
      <div className={"welcome-text"}>
        <p>
          Your health goals deserve more than guesswork. When you book your initial consultation with Ash, you get a personal assessment built around your body.
        </p>
        <p>
          This is the first step toward a plan that actually works for you.
        </p>
      </div>
      <Link to={PAGE_ROUTES.BOOK}>
        <Button
          variant={"contained"}
          color={"primary"}
          style={styles.headerButton}
        >
          Book now
        </Button>
      </Link>
    </section>

    {/* ================================== FIRST SESSION ================================== */}
    <section className={"home-sub-section"}>
      <div className={"home-sub-content"}>
        <h2 className={"section-head"}>What Does The First Session Look Like?</h2>
        <p>
          Your initial consultation is an assessment session. Ash will use InBody270/770 body composition analysis, and factor in everything from any available blood results, clinical signs, dietary and medical history, and lifestyle factors.
        </p>
        <p>
          All of this informs the meal plan Ash builds for you. You'll then book a second session to collect your personalised plan. (Vitality points can be awarded for this session.)
        </p>
        <Link to={PAGE_ROUTES.BOOK}>
          <Button
            variant={"contained"}
            color={"primary"}
            style={styles.headerButton}
          >
            Book now
          </Button>
        </Link>
      </div>
      <img
        className={"home-sub-img"}
        src={"/images/services/about.webp"}
        alt={"What does the first session look like"}
      />
    </section>

    {/* ================================== REST OF JOURNEY ================================== */}
    <section className={"welcome-text-section standard-width"}>
      <h2 className={"section-head"}>The Rest Of The Journey</h2>
      <div className={"welcome-text"}>
        <p>
          Once your plan is in hand, follow-up sessions keep you supported and on track. These consultations monitor your progress, adjust your dietary intake as needed, and keep you accountable. Every follow-up includes an InBody report, so you can see your actual progress.
        </p>
        <p>
          You decide how many follow-ups you need.
        </p>
      </div>
      <Link to={PAGE_ROUTES.BOOK}>
        <Button
          variant={"contained"}
          color={"primary"}
          style={styles.headerButton}
        >
          Book now
        </Button>
      </Link>
    </section>
  </main>
);

export default Welcome;
